import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import { REQUEST_DROP_EVENT_INVOICE } from 'root/src/shared/descriptions/endpoints/endpointIds'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'
import { DROP_EVENT_PAGE_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import {
	INVOICE_SENT_CHECK_EMAIL,
} from 'root/src/shared/descriptions/modules/moduleIds'
import currentRouteParamsRecordId
	from 'root/src/client/logic/route/selectors/currentRouteParamsRecordId'

export default paymentData => async (dispatch, getState) => {
	const state = getState()
	const dropEventId = currentRouteParamsRecordId(state)

	const { body, error } = await dispatch(
		apiRequest(REQUEST_DROP_EVENT_INVOICE, { id: dropEventId, paymentData }),
	)

	if (error) {
		throw error
	}

	const { mnemonicId } = body

	return pushRouteClient({
		routeId: DROP_EVENT_PAGE_ROUTE_ID,
		routeParams: { recordId: mnemonicId },
		query: { modal: INVOICE_SENT_CHECK_EMAIL },
	})
}
